<template>
	<section class="insicht insicht--fade-up">
		<div
      class="container container--narrow-plus"
      v-if="initialError"
    >
			<GeneralMessage
				ref="initialError"
				v-if="initialError"
				:message="initialError"
				type="error"
			/>
		</div>
		<div class="vouchers__form">
			<ValidationObserver
				ref="form"
				v-slot="{ invalid, errors }"
				tag="form"
				class="vouchers__form-wrapper"
				novalidate
				@submit.prevent="onSubmit"
			>
        <GeneralMessage
          ref="message"
          v-if="response.message"
          :message="response.message"
          :type="response.type"
          stick
        />
				<div class="form-row">
					<ValidationProvider
						class="form-row__wrapper"
						name="reloadValue"
						rules="required"
						v-slot="{ errors, invalid, validated }"
						tag="div"
						:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
					>
						<FormInput
							type="number"
							:placeholder="$t('vouchers.amountLabel')"
							:label="$t('vouchers.amountLabel')"
							v-model="form.value"
							:error="errors.length > 0"
							:error-message="errors[0]"
							required
						/>
					</ValidationProvider>
				</div>
				<div class="form-row">
					<ValidationProvider
						class="form-row__wrapper"
						name="reloadCardNumber"
						rules="required"
						v-slot="{ errors, invalid, validated }"
						tag="div"
						:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
					>
						<FormInput
							type="text"
							:placeholder="$t('vouchers.cardNumberLabel')"
							:label="$t('vouchers.cardNumberLabel')"
							v-model="form.cardNumber"
							:error="errors.length > 0"
							:error-message="errors[0]"
              :hint="$t('vouchers.cardNumberHint')"
							required
						/>
					</ValidationProvider>
					</div>
					<div class="form-row">
					<ValidationProvider
						class="form-row__wrapper"
						name="reloadCVC"
						rules="required"
						v-slot="{ errors, invalid, validated }"
						tag="div"
						:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
					>
						<FormInput
							type="text"
							:placeholder="$t('vouchers.cvcLabel')"
							:label="$t('vouchers.cvcLabel')"
							v-model="form.cvc"
							:error="errors.length > 0"
							:error-message="errors[0]"
              :hint="$t('vouchers.cvcHint')"
							required
						/>
					</ValidationProvider>
				</div>

				<Button
					type="submit"
					level="primary"
					:text="$t('vouchers.reloadButton')"
					:disabled="formLocked"
				/>
			</ValidationObserver>
		</div>

		<Modal
			ref="videoModal"
		>
			<div
				class="overlay-video"
				v-html="videoEmbedCode"
			/>
		</Modal>
	</section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { mapGetters } from "vuex"
import FormInput from "@/components/FormInput"
import FormInputTextarea from "@/components/FormInputTextarea"
import FormInputCheckbox from "@/components/FormInputCheckbox"
import GenericMixin from '@/mixins/GenericVueMixin'
import QuantityCounter from '@/components/QuantityCounter';
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'
import Modal from '@/components/Modal'
import { format } from '@/utils/format'
import videoEmbed from '@/utils/videoEmbed'
import {contaoService, datatrans} from '@/service';

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		FormInputTextarea,
		FormInputCheckbox,
		Button,
		GeneralMessage,
		Modal,
		QuantityCounter
	},
	data() {
		return {
			initialError: this.$root.options.initialError,
			content: this.$root.options.content,
			config: this.$root.options.config,
			form: {
				value: '',
				cardNumber: '',
				cvc: '',
			},
			response: {
				type: 'info',
				message: '',
			},
			formLocked: false,
			videoEmbedCode: '',
		}
	},
	computed: {
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
	},
	methods: {
		onVideoClick(url) {
			this.videoEmbedCode = videoEmbed(url);
			this.$refs.videoModal.open();
		},
		async onSubmit(e) {
			e.preventDefault();

			const valid = await this.$refs.form.validate();

			if (valid) {
				this.loading = true;
				try {
					const response = await contaoService.reloadVoucher({
						...this.form,
						value: this.form.value, // convert to cent price
						lang: this.language
					});

					if (response.status) {
						this.response.message = '';
						this.loading = false;

						let result = await datatrans.payment({
							amount: this.form.value * 100, // convert to cent price,
							ref: response.ref,
							merchantId: this.config.merchantId,
							sign: response.sign,
							successUrl: format(this.config.successUrl, {ref: response.ref}),
							cancelUrl: format(this.config.cancelUrl, {ref: response.ref}),
							errorUrl: format(this.config.errorUrl, {ref: response.ref}),
							additionalData: {
								action: 'reload',
								language: this.language,
							}
						});
					}
					else {
						this.response.message = response.error;
						this.response.type = 'error';
						this.$nextTick(() => {
							this.$refs.message.$el.scrollIntoView();
						});
						this.loading = false;
					}
				}
				catch(error) {
					this.response.message = error.message;
					this.response.type = 'error';
					this.loading = false;
				}
			}
		},
		resetForm() {
			this.$refs.form && this.$refs.form.reset();
			this.form.value = '';
			this.form.cardNumber = '';
			this.form.cvc = '';
		},
	},
	created() {
		this.loading = true;
	},
	mounted() {
		this.loading = false;
	}
};
</script>

<style>
</style>
